export default __webpack_public_path__ + "4b7831467dec407b368f72de3a82e9a6.png";